var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Edit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen",
    d: "M14.163.615a2.2,2.2,0,0,0-3.113,0L10.27,1.4l-8.3,8.292-.018.018s0,.009-.009.009-.022.026-.031.04,0,0,0,.009S1.9,9.788,1.89,9.8s0,.009-.009.013-.009.022-.013.035,0,0,0,.009L.023,15.394a.433.433,0,0,0,.106.449.443.443,0,0,0,.313.128.52.52,0,0,0,.141-.022L6.113,14.1s0,0,.009,0a.159.159,0,0,0,.04-.018.016.016,0,0,0,.009,0l.044-.027c.013-.009.026-.022.04-.031s.009,0,.009-.009.013-.009.018-.018l9.075-9.076a2.2,2.2,0,0,0,0-3.114ZM5.972,13.069,2.907,10l7.671-7.671L13.643,5.4Zm-3.5-2.25L5.153,13.5l-4.02,1.339ZM14.735,4.3l-.467.471L11.2,1.707l.471-.471a1.321,1.321,0,0,1,1.867,0l1.2,1.2A1.325,1.325,0,0,1,14.735,4.3Zm0,0",
    transform: "translate(0 0.029)",
    fill: "#2a3c50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Edit);
export default __webpack_public_path__ + "static/media/icons8-edit_.a64afae336e0e21cb634b1ae49e00fde.svg";
export { ForwardRef as ReactComponent };